import { useQuery } from 'react-query';

import { getZipcCodeData } from './ZipCodes.service';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useZipCode(zipCode?: string, enabled = true) {
  const cache = queryClient.getQueryData(['zip-codes', zipCode]);

  const query = useQuery(
    ['zip-codes', zipCode],
    () => (zipCode ? getZipcCodeData(zipCode) : undefined),
    {
      onError(error) {
        notificationError(error, {
          translate: (errors) =>
            errors.map((err) =>
              err.includes('Recurso não encontrado')
                ? 'Digite um CEP existente'
                : err,
            ),
        });
      },
      enabled: enabled && !!zipCode && !cache,
      retry: 0,
    },
  );

  return query;
}
